<template>
  <v-card class="border-0 shadow-off ma-auto" max-width=""
    @add-edit-checklist-item="addEditChecklistItem" data-testid="task-edit-details"
  >
    <!-- <v-card-title class="font-weight-medium" data-testid="task-edit-details__title">
    </v-card-title> -->
    <v-card-text class="pa-0 border-0" data-testid="task-edit-details__body">
      <v-row data-testid="task-edit-details__layout">
        <v-col cols="6" data-testid="task-edit-details__left-col">
          <v-row class="ma-0" data-testid="task-edit-details__row-description">
            <v-col cols="12" class="my-1 pa-1 min-height-textarea" data-testid="task-edit-details__field-description-wrapper">
              <p class="gray--text pa-0 ma-0 text-font-size-md mb-1" data-testid="task-edit-details__label-description">Task Description*</p>
              <lb-textarea
                v-model="addeditdata.description"
                label=""
                rows="2"
                :hidedetails="true"
                :isRequired="true"
                :error="localErrors.description"
                :disabled="isUserEditable"
                data-testid="task-edit-details__description"
                
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" data-testid="task-edit-details__row-category">
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-category-wrapper">
              <p class="pa-0 ma-0 text-font-size-md gray--text mb-1" data-testid="task-edit-details__label-category">Category*</p>
              <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                :multiple="false"
                v-model="addeditdata.category"
                :items="coaCategoryAccComputed"
                appendiconinner="mdi-chevron-down"
                :disabled="isUserEditable"
                data-testid="task-edit-details__category"
                :error="localErrors.category"
              />
              <lb-tagsInput v-else
                :multiplechips="false"
                v-model="addeditdata.category"
                :items="categoryAccComputed"
                :disabled="isUserEditable"
                data-testid="task-edit-details__category"
                :error="localErrors.category"
              />
            </v-col>
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-subcategory-wrapper">
              <p class="pa-0 ma-0 gray--text text-font-size-md mb-1" data-testid="task-edit-details__label-subcategory">Sub Category*</p>
              <lb-dropdown v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
                :multiple="false"
                v-model="addeditdata.subcategory"
                :items="coaSubcategoryAccComputed"
                appendiconinner="mdi-chevron-down"
                :disabled="isUserEditable"
                data-testid="task-edit-details__subcategory"
                :error="localErrors.subcategory"
              />
              <lb-tagsInput v-else
                :multiplechips="false"
                v-model="addeditdata.subcategory"
                :error="localErrors.subcategory"
                :items="subcategoryAccComputed"
                appendiconinner="mdi-chevron-down"
                :disabled="isUserEditable"
                data-testid="task-edit-details__subcategory"
              />
            </v-col>
            
          </v-row>
          <v-row class="ma-0" data-testid="task-edit-details__row-tasktype-duedate">
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-tasktype-wrapper">
                <p class="gray--text ma-0 pa-0 text-font-size-md mb-1" data-testid="task-edit-details__label-task-type">Task Type*</p>
                <lb-dropdown
                  v-model="addeditdata.task_type"
                  :items="allowedTaskTypes"
                  itemtext="name"
                  itemvalue="value"
                  :error="localErrors.task_type"
                  label=""
                  :disabled="isTaskTypeDisabled || isUserEditable || isAccountReconInitiallyData"
                  data-testid="task-edit-details__task-type"
                />
            </v-col>
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-duedate-wrapper">
              <p class="gray--text ma-0 pa-0 text-font-size-md mb-1" data-testid="task-edit-details__label-due-date">Due Date*</p>
              <lb-date
                v-model="addeditdata.duedate"
                label=""
                :error="localErrors.duedate"
                :disabled="isUserEditable"
                :min="dueDateMinDate"
                :max="dueDateMaxDate"
                data-testid="task-edit-details__due-date"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" data-testid="task-edit-details__row-assertions">
            <v-col cols="12" class="my-1 pa-1" data-testid="task-edit-details__field-assertions-wrapper">
              <p class="gray--text pa-0 ma-0 text-font-size-md mb-1" data-testid="task-edit-details__label-assertions">Assertions</p>
              <lb-tagsInput
                v-model="addeditdata.assertions"
                :hidedetails="true"
                :items="possibleAssertions"
                label=""
                :error="localErrors.assertions"
                tagcolor="purpleborder"
                :multiple="true"
                :multiplechips="true"
                :disabled="isUserEditable"
                :chip-close="isEditAllowed"
                data-testid="task-edit-details__assertions"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" data-testid="task-edit-details__right-col">
          <v-row class="ma-0" data-testid="task-edit-details__row-purpose-instruction">
            <v-col cols="6" class="my-1 pa-1 min-height-textarea" data-testid="task-edit-details__field-purpose-wrapper">
              <p class="gray--text ma-0 pa-0 text-font-size-md mb-1" data-testid="task-edit-details__label-purpose">Purpose</p>
              <lb-textarea
                v-model="addeditdata.purpose"
                label=""
                height=""
                :hidedetails="true"
                :error="localErrors.purpose"
                :disabled="isUserEditable"
                data-testid="task-edit-details__purpose"
              />
            </v-col>
            <v-col cols="6" class="my-1 pa-1 min-height-textarea" data-testid="task-edit-details__field-instruction-wrapper">
              <p class="gray--text ma-0 pa-0 text-font-size-md mb-1" data-testid="task-edit-details__label-instruction">Instruction</p>
              <lb-textarea
                v-model="addeditdata.instruction"
                label=""
                :error="localErrors.instruction"
                height="100"
                :hidedetails="true"
                :disabled="isUserEditable"
                data-testid="task-edit-details__instruction"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" data-testid="task-edit-details__row-priority-tags">
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-priority-wrapper">
              <p class="gray--text ma-0 pa-0 text-font-size-md mb-1" data-testid="task-edit-details__label-priority">Priority*</p>
              <lb-dropdown
                v-model="addeditdata.priority"
                :items="priorityList"
                :error="localErrors.priority"
                label=""
                :disabled="isUserEditable"
                data-testid="task-edit-details__priority"
              />
            </v-col>
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-tags-wrapper">
              <p class="gray--text pa-0 ma-0 text-font-size-md mb-1" data-testid="task-edit-details__label-tags">Tags</p>
              <lb-tagsInput
                tagcolor="purpleborder"
                :multiple="true"
                v-model="addeditdata.tags"
                :multiplechips="true"
                :items="Alltags"
                :error="localErrors.tags"
                :disabled="isUserEditable"
                :chip-close="isEditAllowed"
                data-testid="task-edit-details__tags"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" data-testid="task-edit-details__row-location-evidence">
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-location-wrapper" :class="{'mandatory-error-border': localErrors.location}">
              <LocationUserSelector
                :location-list="locationListComputed"
                :users-list="usersListComputed"
                :showlocationanduser.sync="showlocationanduser"
                :selected-location.sync="addeditdata.location"
                :preparer.sync="addeditdata.preparer"
                :approver.sync="addeditdata.approver"
                :is-read-only="isUserEditable"
                data-testid="task-edit-details__location-user-selector"
                :metadata="addeditdata.metadata"
              />
            </v-col>
            <v-col cols="6" class="my-1 pa-1" data-testid="task-edit-details__field-evidences-wrapper">
              <p class="gray--text pa-0 ma-0 text-font-size-md mb-1" data-testid="task-edit-details__label-evidences">No. of Evidences</p>
              <v-text-field
                v-model.number="addeditdata.no_of_evidence"
                type="number"
                :min="0"
                :max="10"
                :step="1"
                outlined
                dense
                :disabled="isUserEditable"
                :error-messages="localErrors.no_of_evidence"
                @input="onEvidenceInput"
                @keypress="(e) => { if (e.key === '.' || e.key === ',') e.preventDefault(); }"
                data-testid="task-edit-details__no-of-evidence"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          class="my-1 py-1"
          v-if="addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION"
        >
          <v-card flat outlined rounded="lg" class="px-3 py-3">
            <div class="d-flex align-center gap-2">
              
              <!-- Icon -->
              <div class="d-flex align-center justify-center">
                <v-icon :color="localSkipValidations ? 'warning' : 'success'" size="20">
                  {{ localSkipValidations ? 'mdi-shield-off-outline' : 'mdi-shield-check-outline' }}
                </v-icon>
              </div>

              <!-- Text -->
              <div class="flex-grow-1">
                <p class="font-weight-medium mb-0" style="color: var(--v-theme-on-surface);">
                  {{ localSkipValidations ? 'Threshold Enforcement Disabled' : 'Threshold Enforcement Enabled' }}
                </p>
                <p class="text-caption grey--text mb-0">
                  {{ localSkipValidations ? 'Bypasses attachment and threshold validations' : 'Applies standard attachment and threshold validations' }}
                </p>
              </div>

              <!-- Toggle -->
              <v-switch
                v-model="localSkipValidations"
                inset
                dense
                color="primary"
                class="mt-0 pt-0 flex-shrink-0"
                hide-details
                :disabled="!isSkipValidationsEditable"
                @change="(val) => $set(addeditdata, 'skipValidations', !!val)"
                data-testid="tasklist__skip-validations"
              />

            </div>
          </v-card>
        </v-col>
        <v-row class="ma-0" data-testid="task-edit-details__row-custom-fields">
          <template v-if="customColumnsComputed && customColumnsComputed.length > 0">
            <v-col cols="12" class="pb-0" data-testid="task-edit-details__custom-fields-header">
              <h4 class="font-weight-regular" data-testid="task-edit-details__custom-fields-title">Custom Fields</h4>
            </v-col>
            <v-col v-for="field in customColumnsComputed" :key="field.columnName" cols="6" :data-testid="`task-edit-details__custom-field-wrapper-${field.columnName}`">
              <p class="ma-0 pa-0 gray--text" :data-testid="`task-edit-details__custom-field-label-${field.columnName}`">{{ field.displayText }}</p>
              <!-- Text Field -->
              <lb-string v-if="field.dataType === 'string'" v-model="addeditdata[field.columnName]"
                 :error="localErrors[field.columnName]" :disabled="isUserEditable" :data-testid="`task-edit-details__custom-field-input-${field.columnName}`" />
              <!-- Date Field -->
              <lb-date v-else-if="field.dataType === 'date'" v-model="addeditdata[field.columnName]"
                 :error="localErrors?.[field.columnName]" :disabled="isUserEditable" :data-testid="`task-edit-details__custom-field-date-${field.columnName}`" />
              <!-- Number Field -->
              <lb-number v-else-if="field.dataType === 'number'" min="0" 
                v-model="addeditdata[field.columnName]" :disabled="isUserEditable" :data-testid="`task-edit-details__custom-field-number-${field.columnName}`" />
              <!-- Fallback (optional) -->
              <lb-textBox v-else v-model="addeditdata[field.columnName]"  :disabled="isUserEditable" :data-testid="`task-edit-details__custom-field-fallback-${field.columnName}`" />
            </v-col>
          </template>
        </v-row>
        <v-col cols="12" class="d-none" v-if="selectglsLocal && selectglsLocal.length > 0 && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION" data-testid="task-edit-details__selected-gls-hidden">
          <span class="font-size-lg font-weight-semibold" data-testid="task-edit-details__selected-gls-title">
            Selected Account
          </span>
          <br />
          <div class="d-flex align-center justify-start flex-wrap " data-testid="task-edit-details__selected-gls-chips">
            <v-chip
              v-for="glcode in selectglsLocal"
              :key="glcode"
              class="caccounting--text lightpurple mt-1 mx-1 d-flex"
              close
              :disabled="isUserEditable"
              @click:close="removeSelectedGl(glcode)"
              :data-testid="`task-edit-details__selected-gl-chip-${glcode}`"
            >
              <span>{{ glcode }}</span>
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" class="d-none" style="height: 10vh" v-if="addeditdata.location && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION" data-testid="task-edit-details__gl-picker-hidden">
          <v-menu
            :close-on-content-click="false"
            offset-y
            transition="slide-y-transition"
            ref="accountMenu"
            data-testid="task-edit-details__gl-picker-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                class="all-width align-center border-on justify-space-between"
                :disabled="isUserEditable"
                data-testid="task-edit-details__gl-picker-btn"
                ><span>Select Account Number</span
                ><v-icon>mdi-chevron-down</v-icon></v-btn
              >
            </template>
            
            <v-list
              class="ma-0 d-flex flex-column align-start justify-start all-width pa-2"
              data-testid="task-edit-details__gl-picker-list"
            >
              <div
                class=""
                style="
                  max-height: 45vh;
                  min-width: 100%;
                  overflow: scroll;
                  z-index: 13 !important;
                  width: 20vh;
                "
                data-testid="task-edit-details__gl-picker-scroll"
              >
                <lb-string
                  label="Search"
                  class="all-width"
                  v-model="searchcustomfilterLocal"
                  hidedetails
                  data-testid="task-edit-details__gl-picker-search"
                />
                <v-simple-table
                  dense
                  class="all-width mt-2 border-on radius-small"
                  data-testid="task-edit-details__gl-picker-table"
                >
                  <thead class="tableHeaderBg">
                    <tr>
                      <th class="gray-background">
                        <v-checkbox
                          class="ma-0 pa-0"
                          hide-details
                          color="caccounting"
                          v-model="selectAllgl"
                          @change="toggleSelectAllGl"
                          data-testid="task-edit-details__gl-picker-select-all"
                        ></v-checkbox>
                      </th>
                      <th class="gray-background" scope="Name">
                        Account No.
                      </th>
                      <th class="gray-background" scope="columns">
                        Account Name
                      </th>
                      <th class="gray-background" scope="ref">Ref</th>
                      <th class="gray-background" scope="location">
                        {{ $store.state.LocationHeader || "Location" }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(v, k) in filteredgllist">
                      <tr :key="k" :data-testid="`task-edit-details__gl-picker-row-${k}`">
                        <td>
                            <v-checkbox
                              class="mt-0"
                              dense
                              label=""
                              :value="String(v.glcode)"
                              v-model="tempGlSelection"
                              multiple
                              hide-details
                              :data-testid="`task-edit-details__gl-picker-row-checkbox-${k}`"
                            ></v-checkbox>
                        </td>
                        <td :data-testid="`task-edit-details__gl-picker-cell-glcode-${k}`">{{ v.glcode }}</td>
                        <td :data-testid="`task-edit-details__gl-picker-cell-name-${k}`">{{ v.name }}</td>
                        <td class="d-flex align-center min-height" :data-testid="`task-edit-details__gl-picker-cell-ref-${k}`">
                          <div
                            v-for="(gg, jj) in v.reference_detail || []"
                            :key="jj"
                            class="d-flex"
                            :data-testid="`task-edit-details__gl-picker-ref-chip-wrapper-${k}-${jj}`"
                          >
                            <v-chip
                              label
                              class="lightpurple caccounting--text mx-1"
                              :data-testid="`task-edit-details__gl-picker-ref-chip-${k}-${jj}`"
                              ><span>{{ gg.ref }}</span></v-chip
                            >
                          </div>
                        </td>
                        <td :data-testid="`task-edit-details__gl-picker-cell-location-${k}`">
                          <div
                            v-for="(vv, kk) in v.location_detail || []"
                            :key="kk"
                            :data-testid="`task-edit-details__gl-picker-location-item-${k}-${kk}`"
                          >
                            <span class="ml-2" :data-testid="`task-edit-details__gl-picker-location-name-${k}-${kk}`">{{ vv.name }}</span>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </v-simple-table>
              </div>
              <div class="d-flex align-center all-width justify-end mt-2">
                <v-btn
                 
                  class="ml-2 white--text"
                  color="primary"
                  @click="
                    addSelectedGls({ skipTrialBalance: true });
                    $refs.accountMenu.isActive = false;
                  "
                  data-testid="task-edit-details__gl-picker-select-btn"
                  ><span>Select</span></v-btn
                >
              </div>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pt-10" v-if="!isUserEditable || (isSkipValidationsEditable && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION && localSkipValidations !== initialSkipValidations)" data-testid="task-edit-details__actions">
      <span class="red--text" v-if="!isUserEditable" data-testid="task-edit-details__required-note">*Required</span>
      <v-spacer></v-spacer>
      <!-- Approver: only skip validation update (account recon only) -->
      <v-btn color="primary" :loading="addeditloading" @click="updateSkipValidationsOnly()" data-testid="task-edit-details__update-skip-btn" v-if="isUserEditable && isSkipValidationsEditable && addeditdata.task_type === $constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION && localSkipValidations !== initialSkipValidations">
        <span data-testid="task-edit-details__update-skip-btn-label">Update</span>
      </v-btn>
      <!-- Manager: full edit flow -->
      <v-btn color="primary" :loading="addeditloading" @click="addEditChecklistItem()" data-testid="task-edit-details__update-btn" v-else-if="addeditdata.task_type === LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME">
        <span data-testid="task-edit-details__update-btn-label">Update</span>
      </v-btn>
       <v-btn color="primary" :loading="addeditloading" @click="linkedGLTab()" data-testid="task-edit-details__update-btn" v-else>
        <span data-testid="task-edit-details__update-btn-label">Next</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import LocationUserSelector from '../../components/LocationUserSelector.vue';
import {  getCustomColumns, getTaskTypeOptions , validateUsersAreActiveAndAttachMessages , activeUserCheckType } from '../../../../utils/utils.js';
import { MESSAGES, LEGACY_TASK_TYPE_LABEL_CHECKLIST, LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME, COMPONENT_EVENTS, MAX_DUE_DATE_DAYS } from '../../../../utils/constants.js';

export default {
  name: 'TaskEditDetails',
  components: {
    LocationUserSelector
  },
  props: {
    addeditdata: { type: Object, default: () => ({}) },
    addeditdataerror: { type: Object, default: () => ({}) },
    addeditdialog: { type: Boolean, default: false },
    categoryAcc: { type: Array, default: () => [] },
    subcategoryAcc: { type: Array, default: () => [] },
    isTaskTypeDisabled: { type: Boolean, default: false },
    customColumns: { type: Array, default: () => [] },
    selectgls: { type: Array, default: () => [] },
    searchcustomfilter: { type: String, default: '' },
  },
  data() {
    const isEditAllowed = (this.$route.query.userType === 'manager');
    // Store the initial value of task_type for disabling logic
    let initialTaskType = '';
    if (this.addeditdata && this.addeditdata.task_type) {
      initialTaskType = this.addeditdata.task_type;
    }
      // Ensure no_of_evidence defaults to 0 if not set
      if (this.addeditdata && (this.addeditdata.no_of_evidence === undefined || this.addeditdata.no_of_evidence === null)) {
        this.$set(this.addeditdata, 'no_of_evidence', 0);
      }
    return {
      localSkipValidations: !!(this.addeditdata && this.addeditdata.skipValidations),
      initialSkipValidations: !!(this.addeditdata && this.addeditdata.skipValidations),
      possibleAssertions: this.$constants.TASK_LIST_CONSTANTS.ASSERTIONS,
      priorityList: this.$constants.TASK_LIST_CONSTANTS.PRIORITY_LIST,
      Alltags: [],
      showlocationanduser: !!(this.addeditdata && this.addeditdata.location),
      addeditloading: false,
      selectglsLocal: [],
      tempGlSelection: [],
      searchcustomfilterLocal: this.searchcustomfilter,
      isEditAllowed,
      initialTaskTypeForDisable: initialTaskType,
      userDetails:{ activeUsers: [], activeUserIds: [] },
      // Local copy of errors to avoid mutating prop
      localErrors: {},
      // Make constants available to template
      LEGACY_TASK_TYPE_LABEL_CHECKLIST,
      LEGACY_TASK_TYPE_LABEL_CHECKLIST_NAME
    };
  },
  created(){
  this.initActiveUsers();
  // Initialize local errors from prop
  this.localErrors = { ...this.addeditdataerror };
  },

  mounted() {
    // If linked GLs exist, sync them to selectglsLocal
    // Prefer __tbtotals.items (has glcodes) over __tblinks (has ObjectIDs)
    if (this.addeditdata && Array.isArray(this.addeditdata.__tbtotals?.items) && this.addeditdata.__tbtotals.items.length > 0) {
      this.selectglsLocal = this.addeditdata.__tbtotals.items.map(item => String(item.glcode));
      this.tempGlSelection = [...this.selectglsLocal];
      this.$emit(COMPONENT_EVENTS.UPDATE_SELECT_GLS, this.selectglsLocal);
    } else if (this.addeditdata && Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
      this.selectglsLocal = [...this.addeditdata.__tblinks].map(String);
      this.tempGlSelection = [...this.selectglsLocal];
      this.$emit(COMPONENT_EVENTS.UPDATE_SELECT_GLS, this.selectglsLocal);
    }
    // Normalize any legacy / display value stored as 'Checklist' back to constant value
  if (this.addeditdata && this.addeditdata.task_type === LEGACY_TASK_TYPE_LABEL_CHECKLIST) {
      this.$set(this.addeditdata, 'task_type', this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL);
    }
    // Sync skipValidations from loaded addeditdata
    this.localSkipValidations = !!(this.addeditdata && this.addeditdata.skipValidations);
    // --- Sync customfields into addeditdata for v-model binding ---
    this.syncCustomFieldsToAddEditData();
  },
  watch: {
    addeditdataerror: {
      handler(newVal) {
        // Sync prop changes to local errors
        this.localErrors = { ...newVal };
      },
      deep: true
    },
    addeditdialog(val) {
      // Only update local selection when dialog is opened
      // Prefer __tbtotals.items (has glcodes) over __tblinks (has ObjectIDs)
      if (val) {
        if (Array.isArray(this.addeditdata.__tbtotals?.items) && this.addeditdata.__tbtotals.items.length > 0) {
          this.selectglsLocal = this.addeditdata.__tbtotals.items.map(item => String(item.glcode));
          this.tempGlSelection = [...this.selectglsLocal];
        } else if (Array.isArray(this.addeditdata.__tblinks) && this.addeditdata.__tblinks.length > 0) {
          this.selectglsLocal = [...this.addeditdata.__tblinks].map(String);
          this.tempGlSelection = [...this.addeditdata.__tblinks].map(String);
        }
        // Sync skipValidations local state when dialog reopens
        this.localSkipValidations = !!(this.addeditdata && this.addeditdata.skipValidations);
        this.initialSkipValidations = this.localSkipValidations;
        // --- Sync customfields into addeditdata for v-model binding ---
        this.syncCustomFieldsToAddEditData();
      }
    },
    searchcustomfilterLocal() {
      // Always keep tempGlSelection as string IDs after search/filter
      this.tempGlSelection = (this.tempGlSelection || []).map(String);
    },
    'addeditdata.task_type'(newType) {
      if (newType === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL) {
        this.selectglsLocal = [];
        this.$emit('update:selectgls', this.selectglsLocal);
      }
      if (newType === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION) {
        const coaCats = this.coaCategoryAccComputed;
        const coaSubs = this.coaSubcategoryAccComputed;
        if (this.addeditdata.category && !coaCats.includes(this.addeditdata.category)) {
          this.$set(this.addeditdata, 'category', '');
        }
        if (this.addeditdata.subcategory && !coaSubs.includes(this.addeditdata.subcategory)) {
          this.$set(this.addeditdata, 'subcategory', '');
        }
      }
    }
  },
    methods: {
      linkedGLTab(){
        if(this.validateRequiredFields() === false){
          return;
        }
       this.$emit(COMPONENT_EVENTS.LINKED_GL_TAB);
      },
      /**
       * Syncs the customfields array of objects into addeditdata as direct properties for v-model binding.
       */
    syncCustomFieldsToAddEditData() {
      if (!this.addeditdata) return;
      if (Array.isArray(this.addeditdata.customfields)) {
        for (const fieldObj of this.addeditdata.customfields) {
          if (fieldObj && typeof fieldObj === 'object') {
            for (const key in fieldObj) {
              if (!(key in this.addeditdata)) {
                this.$set(this.addeditdata, key, fieldObj[key]);
              }
            }
          }
        }
      }
    },
    async initActiveUsers() {
      // Use formDataV3 cached in store (already fetched by fetchTask/getAllTasks)
      // Falls back to getAllUsersWithStatus only if formDataV3 is not available
      const formData = this.$store.getters['tasks/getFormDataV3'];
      if (formData && formData.users) {
        const activeUsers = formData.users.filter(u => u.isActive);
        const activeUserIds = activeUsers.map(u => u._id).filter(Boolean);
        this.$set(this.userDetails, 'activeUsers', activeUsers);
        this.$set(this.userDetails, 'activeUserIds', activeUserIds);
      } else {
        // Fallback: fetch from legacy endpoint
        try {
          await this.$store.dispatch("tasks/getAllUsersWithStatus", { isActiveUsersRequired: true });
          this.$set(this.userDetails, 'activeUsers', this.$store.getters["tasks/getActiveUsersList"] || []);
          this.$set(this.userDetails, 'activeUserIds', this.$store.getters["tasks/getActiveUsersIds"] || []);
        } catch (error) {
          console.error("Error fetching users:", error);
          this.$store.commit("sbError", MESSAGES.FAILED_TO_GET_USERS);
          this.$set(this.userDetails, 'activeUsers', []);
          this.$set(this.userDetails, 'activeUserIds', []);
        }
      }
    },
    // GL removal logic
    removeSelectedGl(glcode) {
      if (!glcode) return;
      const glcodeStr = String(glcode);
      // Remove from both selectglsLocal and tempGlSelection (as strings)
      this.selectglsLocal = this.selectglsLocal.map(String).filter(code => code !== glcodeStr);
      this.tempGlSelection = this.tempGlSelection.map(String).filter(code => code !== glcodeStr);
      // Only update selected GLs and emit, do not recalculate tbtotals
      this.addSelectedGls({ skipTrialBalance: true });
      // Do NOT call update API here; update only on explicit Update button click
    },

    // Only update tempGlSelection, chips update only on Select button click
    toggleSelectAllGl() {
      const filteredCodes = this.filteredgllist.map(gl => String(gl.glcode));
      if (this.selectAllgl) {
        // Add all filteredgllist items to tempGlSelection (merge, avoid duplicates)
        this.tempGlSelection = Array.from(new Set([
          ...this.tempGlSelection.map(String),
          ...filteredCodes
        ]));
      } else {
        // Remove only filteredgllist items from tempGlSelection
        this.tempGlSelection = this.tempGlSelection.map(String).filter(code => !filteredCodes.includes(code));
      }
      // Chips (selectglsLocal) are NOT updated here, only on Select button click
    },
  // Removed getLocationById, getNameById, togglePreparer, toggleApprover (now handled by LocationUserSelector)
    // GL selection logic (matches Tasklist.vue)
    addSelectedGls({ skipTrialBalance = false } = {}) {
      // Set checked accounts to exactly what's selected (not merged)
      this.selectglsLocal = [...(this.tempGlSelection || [])].map(String);
      // Only update trial balance if not skipped
      if (!skipTrialBalance) {
        const selectedItems = [];
        for (const code of this.selectglsLocal) {
          const glItem = this.tbMap[String(code)];
          if (glItem) selectedItems.push(glItem);
        }
        let total = 0;
        for (const gl of selectedItems) {
          if (gl && gl.closing_amount != null && gl.closing_amount !== '') {
            const amt = parseFloat(gl.closing_amount);
            if (!isNaN(amt)) total += amt;
          }
        }
        this.addeditdata.__tbtotals = {
          total,
          items: selectedItems,
        };
      }
      // Convert glcodes to _ids for __tblinks (backend expects object IDs)
      const tblinks = this.selectglsLocal.map(code => {
        const entry = this.tbMap[String(code)];
        return entry && entry._id ? String(entry._id) : String(code);
      });
      this.addeditdata.__tblinks = tblinks;
      this.$emit(COMPONENT_EVENTS.UPDATE_SELECT_GLS, [...this.selectglsLocal]);
    },
    async updateSkipValidationsOnly() {
      this.addeditloading = true;
      try {
        // Convert glcodes to _ids for backend payload
        const selectglsAsIds = this.selectglsLocal.map(code => {
          const entry = this.tbMap[String(code)];
          return entry && entry._id ? String(entry._id) : String(code);
        });
        const payload = {
          addeditdata: { ...this.addeditdata },
          customColumns: this.customColumnsComputed,
          selectglsLocal: selectglsAsIds,
        };
        const result = await this.$store.dispatch('tasks/addEditChecklistItem', payload);
        if (result && result.success) {
          this.$store.commit('sbSuccess', 'Skip validations updated');
          this.initialSkipValidations = this.localSkipValidations;
          this.$emit(COMPONENT_EVENTS.CHECKLIST_ITEM_UPDATED, { data: { ...result.data, _id: this.addeditdata._id } });
          const checklistId = this.addeditdata.project || this.addeditdata._id;
          await this.$store.dispatch('tasks/getAllTasks', checklistId ? { checklistId } : {});
          this.$emit(COMPONENT_EVENTS.REFRESH);
        } else {
          this.$store.commit('sbError', result?.errorMessage || 'Failed to update');
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || 'Unknown error!');
        console.error('[TaskEditDetails]: updateSkipValidationsOnly error', err);
      } finally {
        this.addeditloading = false;
      }
    },
    async addEditChecklistItem() {

      this.addeditloading = true;
      try {
        // Validate required fields
        if (!this.validateRequiredFields()) {
          this.addeditloading = false;
          return;
        }

        if(!this.validateUsersAreActive()) {
          this.addeditloading = false;
          return;
        }
        // Convert glcodes to _ids for backend payload
        const selectglsAsIds = this.selectglsLocal.map(code => {
          const entry = this.tbMap[String(code)];
          return entry && entry._id ? String(entry._id) : String(code);
        });
        const payload = {
          addeditdata: { ...this.addeditdata },
          customColumns: this.customColumnsComputed,
          selectglsLocal: selectglsAsIds,
        };
        const result = await this.$store.dispatch('tasks/addEditChecklistItem', payload);
        if (result && result.success) {
          this.$store.commit('sbSuccess', 'Tasklist item updated');
          // Use tbMap for O(1) GL lookups
          const tbMap = this.tbMap;
          const items = (this.selectglsLocal || []).map(code => tbMap[String(code)]).filter(Boolean);
          this.$emit(COMPONENT_EVENTS.CHECKLIST_ITEM_UPDATED, { data: { ...result.data, _id: this.addeditdata._id, __tblinks: selectglsAsIds, __tbtotals: { ...result.data.__tbtotals, items } } });
          const checklistId = this.addeditdata.project || this.addeditdata._id;
          await this.$store.dispatch('tasks/getAllTasks', checklistId ? { checklistId } : {});
          this.$emit(COMPONENT_EVENTS.REFRESH);
        } else {
          if (result && result.errorMessage) {
            this.$store.commit('sbError', result.errorMessage);
          } else if (result && result.data && result.data.index0) {
            this.localErrors = result.data.index0;
            this.$store.commit('sbError', 'Validation error');
          } else {
            this.$store.commit('sbError', 'Unknown error!');
          }
        }
      } catch (err) {
        this.$store.commit('sbError', err.message || err || 'Unknown error!');
        console.log(err);
      } finally {
        this.addeditloading = false;
      }
      },
      validateUsersAreActive() {
        const { valid, messages } = validateUsersAreActiveAndAttachMessages(
          this.addeditdata,
          this.userDetails.activeUsers,
          this.taskListData.usersList,
          activeUserCheckType.EDIT_TASK
        );
        if (!valid && messages.length) {
          this.$store.commit('sbError', messages.join(' '));
        }
        return valid;
    },
    validateRequiredFields() {
      this.localErrors = {};
      // Reset all errors
      Object.keys(this.localErrors).forEach(key => {
        this.$set(this.localErrors, key, '');
      });

      let isValid = true;
      // const errors = [];

      // Helper function to check if a value is empty
      const isEmpty = (value) => {
        if (value === null || value === undefined) return true;
        if (typeof value === 'string' && value.trim().length === 0) return true;
        if (Array.isArray(value) && value.length === 0) return true;
        return false;
      };

      // Validate description
      if (isEmpty(this.addeditdata.description)) {
        this.$set(this.localErrors, 'description', 'Task Description is required');
        isValid = false;
      }

      // Validate category
      if (isEmpty(this.addeditdata.category)) {
        this.$set(this.localErrors, 'category', 'Category is required');
        isValid = false;
      }
      
      // Validate subcategory
      if (isEmpty(this.addeditdata.subcategory)) {
        this.$set(this.localErrors, 'subcategory', 'Sub Category is required');
        isValid = false;
      }

      // Validate task_type
      if (isEmpty(this.addeditdata.task_type)) {
        this.$set(this.localErrors, 'task_type', 'Task Type is required');
        isValid = false;
      }

      // Validate duedate
      if (isEmpty(this.addeditdata.duedate)) {
        this.$set(this.localErrors, 'duedate', 'Due Date is required');
        isValid = false;
      }

      // Validate priority
      if (isEmpty(this.addeditdata.priority)) {
        this.$set(this.localErrors, 'priority', 'Priority is required');
        isValid = false;
      }

      // Validate location
      if (isEmpty(this.addeditdata.location)) {
        this.$set(this.localErrors, 'location', 'Location is required');
        isValid = false;
      }

      // Validate preparer
      if (isEmpty(this.addeditdata.preparer)) {
        isValid = false;
      }

      // Validate approver
      if (isEmpty(this.addeditdata.approver)) {
        isValid = false;
      }

      // Display error message if validation fails
      if (!isValid) {
        this.$store.commit('sbError', 'Please fill all required fields');
      }

      return isValid;
    },
    refreshData() {
        // Emit event to parent to handle refresh
        this.$emit(COMPONENT_EVENTS.REFRESH);
    },
    onEvidenceInput(val) {
      if (typeof val !== 'number') val = Number(val);
      val = Math.floor(val);
      if (val < 0 || val > 10) {
        this.localErrors.no_of_evidence = ['Please enter a value between 0 and 10.'];
      } else {
        this.localErrors.no_of_evidence = '';
      }
      this.addeditdata.no_of_evidence = val;
    },
  },
  computed: {
    dueDateMinDate() {
      return this.$nova.formatDateISO(new Date());
    },

     dueDateMaxDate() {
      const today = new Date();
      const maxDate = new Date(today);
      maxDate.setDate(maxDate.getDate() + MAX_DUE_DATE_DAYS);
      return this.$nova.formatDateISO(maxDate);
    },
    isAccountReconInitiallyData() {
      // Disable only if the initial value was ACCOUNT_RECONCILIATION
      return this.initialTaskTypeForDisable === this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },
    isSkipValidationsEditable() {
      const userType = this.$route.query.userType;
      if (userType === 'manager') return true;
      if (userType === 'approver') return this.addeditdata.stage === 0;
      return false;
    },
    isUserEditable() {
      // Editable only if isEditAllowed is true (manager) 
      return !this.isEditAllowed;
    },
    taskListData() {
      return this.$store.getters['tasks/getTaskListData'] || {};
    },
    categoryAccComputed() {
      if (this.taskListData.categoryAcc && this.taskListData.categoryAcc.length) {
        return this.taskListData.categoryAcc;
      }
      const arr = this.taskListData.chartAcc || this.chartAcc || [];
      return [...new Set(arr.map(item => item.category).filter(Boolean))];
    },
    subcategoryAccComputed() {
      let items;
      if (this.taskListData.subcategoryAcc && this.taskListData.subcategoryAcc.length) {
        items = this.taskListData.subcategoryAcc;
      } else {
        const arr = this.taskListData.chartAcc || this.chartAcc || [];
        items = [...new Set(arr.map(item => item.subcategory).filter(Boolean))];
      }
      // Ensure the current value is always present so the input can display it
      const current = this.addeditdata && this.addeditdata.subcategory;
      if (current && !items.includes(current)) {
        items = [current, ...items];
      }
      return items;
    },
    coaCategoryAccComputed() {
      if (this.taskListData.coaCategoryAcc && this.taskListData.coaCategoryAcc.length) {
        return this.taskListData.coaCategoryAcc;
      }
      const arr = this.taskListData.chartAcc || this.chartAcc || [];
      return [...new Set(arr.map(item => item.category).filter(Boolean))];
    },
    coaSubcategoryAccComputed() {
      let items;
      if (this.taskListData.coaSubcategoryAcc && this.taskListData.coaSubcategoryAcc.length) {
        items = this.taskListData.coaSubcategoryAcc;
      } else {
        const arr = this.taskListData.chartAcc || this.chartAcc || [];
        items = [...new Set(arr.map(item => item.subcategory).filter(Boolean))];
      }
      // Ensure the current value is always present so the dropdown can display it
      const current = this.addeditdata && this.addeditdata.subcategory;
      if (current && !items.includes(current)) {
        items = [current, ...items];
      }
      return items;
    },
    customColumnsComputed() {
      // Find the first checklist item with a non-empty customfields array
      const checklist = this.taskListData.checklist || [];
      let mergedCustomFields = {};
      for (const item of checklist) {
        if (Array.isArray(item.customfields) && item.customfields.length > 0) {
          // Merge all key-value pairs from the array of objects
          for (const fieldObj of item.customfields) {
            if (fieldObj && typeof fieldObj === 'object') {
              Object.assign(mergedCustomFields, fieldObj);
            }
          }
        }
      }
      // Use imported getCustomColumns utility to generate columns config
      try {
        return getCustomColumns(mergedCustomFields);
      } catch (e) {
        // fallback: return empty array
        return [];
      }
    },
    locationListComputed() {
      const loc = this.taskListData.locationList || this.locationList;
      if (Array.isArray(loc)) return loc;
      if (loc && Array.isArray(loc.country)) return loc.country;
      if (loc && Array.isArray(loc.locations)) return loc.locations;
      if (loc && typeof loc === 'object') {
        const vals = Object.values(loc).filter(v => Array.isArray(v));
        if (vals.length > 0) return vals[0];
      }
      return [];
    },
    usersListComputed() {
      return this.taskListData.usersList || this.usersList;
    },
    allowedTaskTypes() {
      // Always derive fresh list to avoid stale references / mutations elsewhere
      try {
        const opts = getTaskTypeOptions();
        // Ensure NORMAL always present
        const normalVal = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.NORMAL;
        if (!opts.find(o => o.value === normalVal)) {
          opts.push({ value: normalVal, name: 'Checklist' });
        }
        // If current value is NORMAL but label mismatch, keep v-model
        if (this.addeditdata && this.addeditdata.task_type === LEGACY_TASK_TYPE_LABEL_CHECKLIST) {
          this.$set(this.addeditdata, 'task_type', normalVal);
        }
        return opts;
      } catch (e) {
        return [];
      }
    },
    filteredgllist() {
      const tb = this.tbComputed;
      if (!Array.isArray(tb)) return [];
      if (!this.searchcustomfilterLocal) {
        return tb.filter(item =>
          item.location_detail && item.location_detail[0] && item.location_detail[0]._id === this.addeditdata.location
        );
      } else {
        return tb.filter(item =>
          item.location_detail && item.location_detail[0] && item.location_detail[0]._id === this.addeditdata.location &&
          Object.values(item).some(val =>
            val !== null && val !== undefined && val.toString && val.toString().toLowerCase().includes(this.searchcustomfilterLocal.toLowerCase())
          )
        );
      }
    },
    tbComputed() {
      // Prefer tb from taskListData (populated by v3 getAllTasks), then fallback to props
      const tb = this.taskListData.tb || this.$props.tb || [];
      return Array.isArray(tb) ? tb : [];
    },
    /**
     * Map of TB item ID → TB object for O(1) GL lookups.
     * Replaces repeated tbComputed.find() calls.
     */
    tbMap() {
      const tb = this.tbComputed;
      const map = {};
      for (const item of tb) {
        if (item && item._id) map[item._id] = item;
        if (item && item.glcode != null) map[String(item.glcode)] = item;
      }
      return map;
    },
    /**
     * O(1) user lookup map from store (backed by formDataV3).
     * Use this.userMap[id]?.name instead of usersList.find().
     */
    userMap() {
      return this.$store.getters['tasks/getUserMap'] || {};
    },
    /**
     * O(1) location lookup map from store (backed by formDataV3).
     * Use this.locationMap[id]?.name instead of locationList.find().
     */
    locationMap() {
      return this.$store.getters['tasks/getLocationMap'] || {};
    },
    selectAllgl: {
      get() {
        const tempCodes = this.tempGlSelection.map(String);
        return this.filteredgllist.length > 0 && this.filteredgllist.every(item => tempCodes.includes(String(item.glcode)));
      },
      set(val) {
        const filteredCodes = this.filteredgllist.map(gl => String(gl.glcode));
        if (val) {
          this.tempGlSelection = Array.from(new Set([
            ...this.tempGlSelection.map(String),
            ...filteredCodes
          ]));
        } else {
          this.tempGlSelection = this.tempGlSelection.map(String).filter(code => !filteredCodes.includes(code));
        }
      }
    },
  }
}
</script>

<style>
.min-height {
  height: 48px !important;
}
.min-height-textarea textarea {
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0 3px 0 0 !important;
  padding-top: 14px !important;
  height: 120px !important;
}
.min-height-textarea .v-input__append-inner {
  position: absolute;
  right: 5px;
}
.mandatory-error-border {
  border: 1.5px solid #b22222 !important;
  border-radius: 6px;
  position: relative;
}
</style>